export class Activity {
	activityId: number;
	activityDate: Date;
	activityProviderId: number;

	// Basic Info
	name: string;
	category: string;      // sea | land | air | culture | food | wellness
	activityType: string;
	emoji: string;
	status: string;        // active | draft | archived
	invoiceType: string;

	// Descriptions
	shortDesc: string;
	fullDesc: string;
	overviewDesc: string;
	detailsDesc: string;
	highlightDesc: string;
	feeDesc: string;
	scheduleDesc: string;
	termsDesc: string;
	leadDescription: string;
	opsNotes: string;

	// Pricing & Capacity
	rate: string;
	minGuests: number;
	maxGuests: number;
	duration: string;
	meetingLocation: string;
	leadTime: string;

	// Tags & Restrictions
	highlights: string;
	tags: string;
	ageRestriction: string;
	physicalRequirement: string;
	internalNote: string;

	// Availability
	availableDays: any;
	startTimes: string;
	seasonal: string;
	blackoutDates: string;
	availabilityNote: string;
	pickUpAvailable: any;
	accessibleTransport: any;
	eatingTime: any;
	language: any;

	// Provider Booking
	bookingUrl: string;
	bookingPhone: string;
	guestInstructions: string;
	cancelPolicy: string;
	commission: string;

	// Properties & Priority
	properties: string;
	priority: number;
	featured: boolean;

	// Display / Front-End
	coverImageUrl: string;
	eyebrowText: string;
	ctaLabel: string;
	badge: string;
	published: boolean;
	allowRequests: boolean;
	showPricing: boolean;
	seasonalBadge: boolean;

	// Address
	adrType: string;
	adrStreetNumber: string;
	adrStreetName: string;
	adrUnit: string;
	adr2: string;
	adrCity: string;
	adrCounty: string;
	adrCountry: string;
	adrRegion: string;
	adrState: string;
	adrPostalCode: string;
	adrIsland: string;
	adrCrossStreet: string;
	adrLongitude: string;
	adrLatitude: string;
	locationCategory: string;

	// Extra Descriptions
	checkInDesc: string;
	parkingDesc: string;
	menuDesc: string;
	durationDesc: string;
}
